import { DataBridgeService } from '../services/data-bridge.service';

export class Utils extends DataBridgeService{
    constructor(){
        super();
    }

    static triggerFootprintAnimation() : any{
        return this.repeateAnimation();
    }
}   